
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefee8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefee8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cT75T", function(module, exports) {

$parcel$export(module.exports, "AccountManager", function () { return $96201fd4d61290bf$export$a1e1c1cb52ebd7df; });

var $7BrIz = parcelRequire("7BrIz");

var $8jIBp = parcelRequire("8jIBp");

var $33R1Y = parcelRequire("33R1Y");
var $96201fd4d61290bf$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $96201fd4d61290bf$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $96201fd4d61290bf$var$KEEP_SIGNED_IN_COOKIE = "keep_signed_in";
var $96201fd4d61290bf$var$ID_TOKEN_STORAGE = "id_token";
var $96201fd4d61290bf$var$REFRESH_TOKEN_STORAGE = "refresh_token";
var $96201fd4d61290bf$export$4b5e90bac1c21735;
(function(AccountManagerEvent) {
    AccountManagerEvent["GuestRequired"] = "guestRequired";
    AccountManagerEvent["LoggedIn"] = "loggedIn";
    AccountManagerEvent["LoggedOut"] = "loggedOut";
})($96201fd4d61290bf$export$4b5e90bac1c21735 || ($96201fd4d61290bf$export$4b5e90bac1c21735 = {}));
var $96201fd4d61290bf$var$paramExtractRegex = /^(?:[^=]+)=(.+)$/;
var $96201fd4d61290bf$var$findCookiePair = function(name) {
    return typeof document !== "undefined" ? document.cookie.split("; ").find(function(row) {
        return row.startsWith("".concat(name, "="));
    }) : undefined;
};
var $96201fd4d61290bf$var$getCookieValue = function(name) {
    var _a;
    return (_a = $96201fd4d61290bf$var$paramExtractRegex.exec($96201fd4d61290bf$var$findCookiePair(name) || "")) === null || _a === void 0 ? void 0 : _a[1];
};
var $96201fd4d61290bf$var$removeCookie = function(name) {
    if (typeof document !== "undefined") document.cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure=true; SameSite=none");
};
var $96201fd4d61290bf$var$getStorageValue = function(name, getPersisted) {
    var _a, _b, _c;
    if (getPersisted) return (_a = window.localStorage.getItem(name)) !== null && _a !== void 0 ? _a : $96201fd4d61290bf$var$getCookieValue(name);
    return (_c = (_b = window.sessionStorage.getItem(name)) !== null && _b !== void 0 ? _b : window.localStorage.getItem(name)) !== null && _c !== void 0 ? _c : $96201fd4d61290bf$var$getCookieValue(name);
};
var $96201fd4d61290bf$var$setStorageValue = function(name, value, persist) {
    if (persist) window.localStorage.setItem(name, value);
    else window.sessionStorage.setItem(name, value);
};
var $96201fd4d61290bf$var$removeStorageValue = function(name) {
    if (typeof window === "undefined") return;
    window.sessionStorage.removeItem(name);
    window.localStorage.removeItem(name);
};
/**
 * Handles current authenticated guest account and session.
 * This class is designed to be used as singleton (@see AccountManager.current.<...>) unless you need to
 * have many instances with different @see IdentityProvider
 */ var $96201fd4d61290bf$export$a1e1c1cb52ebd7df = /** @class */ function() {
    function AccountManager(identityProvider) {
        var _a;
        this._registeredEvents = (_a = {}, _a[$96201fd4d61290bf$export$4b5e90bac1c21735.GuestRequired] = new Set(), _a[$96201fd4d61290bf$export$4b5e90bac1c21735.LoggedIn] = new Set(), _a[$96201fd4d61290bf$export$4b5e90bac1c21735.LoggedOut] = new Set(), _a);
        this._identityProvider = identityProvider;
    }
    Object.defineProperty(AccountManager.prototype, "guest", {
        /**
         * Returns the current Guest or undefined. You should not use this and prefer {@link guestAsync} instead
         * as {@link guestAsync} will attempt to silently log in the guest
         */ get: function() {
            var _a;
            return (0, $33R1Y.IdentityProvider).isTokenExpired((0, $33R1Y.IdentityProvider).getInfoFromToken((_a = this._guest) === null || _a === void 0 ? void 0 : _a.idToken)) ? undefined : this._guest;
        },
        set: function(guest) {
            if (!guest) throw new Error("`guest` is undefined, please set a correct value!");
            this._guest = guest;
            $96201fd4d61290bf$var$setStorageValue($96201fd4d61290bf$var$ID_TOKEN_STORAGE, guest.idToken);
            if (guest.refreshToken) $96201fd4d61290bf$var$setStorageValue($96201fd4d61290bf$var$REFRESH_TOKEN_STORAGE, guest.refreshToken, guest.keepSignedIn);
            this.fireLoggedInEvent(guest);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Resets the state of current object to initial. This object is capable to recover
     * appropriate state from external storages after reset. So ensure those updated before interacting with
     * AccountManager after reset. You do not need to reattach events.
     */ AccountManager.prototype.resetState = function() {
        this._guest = undefined;
    };
    AccountManager.prototype.getGuestAsync = function(mustReturnOrThrow) {
        var _a, _b;
        return $96201fd4d61290bf$var$__awaiter(this, void 0, Promise, function() {
            var guest, _c, _d;
            return $96201fd4d61290bf$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        if (!((_a = this.guest) !== null && _a !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = _a;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.tryGetGuestSilentlyAsync()
                        ];
                    case 2:
                        _d = _e.sent();
                        _e.label = 3;
                    case 3:
                        if (!((_b = _d) !== null && _b !== void 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _c = _b;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            this.fireGuestRequiredEventAsync()
                        ];
                    case 5:
                        _c = _e.sent();
                        _e.label = 6;
                    case 6:
                        guest = _c;
                        if (mustReturnOrThrow && !guest) {
                            this._guest = undefined;
                            throw new (0, $8jIBp.UnauthorizedError)("Unable to obtain guest information!");
                        }
                        if (guest && guest !== this._guest) this.guest = guest; // We use this._guest here as we want to trigger LoggedIn event for this action
                        return [
                            2 /*return*/ ,
                            guest
                        ];
                }
            });
        });
    };
    Object.defineProperty(AccountManager, "current", {
        /**
         * Returns the only singleton instance of this class
         */ get: function() {
            return $96201fd4d61290bf$var$currentManager;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds a listener for events happening in this provider
     * @param event - event type
     * @param listener - a listener function which will be called when event is fired
     */ AccountManager.prototype.addEventListener = function(event, listener) {
        if (event === $96201fd4d61290bf$export$4b5e90bac1c21735.GuestRequired) {
            // We only support one listener for GuestRequired event
            var list = this.getEventSet(event);
            list.clear();
            list.add(listener);
        }
        this.getEventSet(event).add(listener);
    };
    /**
     * Removes a listener
     * @param event - event type
     * @param listener - a listener function instance which was sent to @see addEventListener
     */ AccountManager.prototype.removeEventListener = function(event, listener) {
        this.getEventSet(event).delete(listener);
    };
    /**
     * Updates guest details in back-end systems
     * @param guestDetailsToUpdate - details to update. Specify only details you need to update
     * @returns all updated and existing details
     */ AccountManager.prototype.updateGuestDetailsAsync = function(guestDetailsToUpdate) {
        var _a;
        if (!((_a = this.guest) === null || _a === void 0 ? void 0 : _a.idToken)) throw new Error("Unauthorized request");
        return this.guest.getOrUpdateDetailsAsync(guestDetailsToUpdate);
    };
    /**
     * Logs guest out and cleanup storage
     */ AccountManager.prototype.logOut = function() {
        $96201fd4d61290bf$var$removeStorageValue($96201fd4d61290bf$var$ID_TOKEN_STORAGE);
        $96201fd4d61290bf$var$removeStorageValue($96201fd4d61290bf$var$REFRESH_TOKEN_STORAGE);
        $96201fd4d61290bf$var$removeCookie($96201fd4d61290bf$var$ID_TOKEN_STORAGE);
        $96201fd4d61290bf$var$removeCookie($96201fd4d61290bf$var$REFRESH_TOKEN_STORAGE);
        $96201fd4d61290bf$var$removeCookie($96201fd4d61290bf$var$KEEP_SIGNED_IN_COOKIE);
        this.fireLoggedOutEvent();
        this.resetState();
    };
    AccountManager.prototype.isTokenExpired = function(token) {
        var jwToken = (0, $33R1Y.IdentityProvider).getInfoFromToken(token);
        if (!(jwToken === null || jwToken === void 0 ? void 0 : jwToken.exp) || Date.now() >= jwToken.exp * (0, $7BrIz.MILLISECONDS_PER_SECOND)) return true;
        return false;
    };
    Object.defineProperty(AccountManager.prototype, "cachedIdToken", {
        get: function() {
            if (typeof window === "undefined") return undefined;
            var idToken = $96201fd4d61290bf$var$getStorageValue($96201fd4d61290bf$var$ID_TOKEN_STORAGE);
            if (this.isTokenExpired(idToken)) return undefined;
            return idToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountManager.prototype, "cachedRefreshToken", {
        get: function() {
            if (typeof window === "undefined") return undefined;
            var refreshToken = $96201fd4d61290bf$var$getStorageValue($96201fd4d61290bf$var$REFRESH_TOKEN_STORAGE);
            if (this.isTokenExpired(refreshToken)) return undefined;
            return refreshToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountManager.prototype, "cachedKeepSignedIn", {
        get: function() {
            var _a;
            if (typeof window === "undefined" || typeof document === "undefined") return false;
            if ($96201fd4d61290bf$var$getStorageValue($96201fd4d61290bf$var$REFRESH_TOKEN_STORAGE, true) || ((_a = $96201fd4d61290bf$var$getCookieValue($96201fd4d61290bf$var$KEEP_SIGNED_IN_COOKIE)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true") return true;
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AccountManager.prototype.tryGetGuestSilentlyAsync = function() {
        return $96201fd4d61290bf$var$__awaiter(this, void 0, Promise, function() {
            var idToken, refreshToken, keepSignedIn, _a;
            return $96201fd4d61290bf$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        idToken = this.cachedIdToken;
                        refreshToken = this.cachedRefreshToken || undefined;
                        keepSignedIn = this.cachedKeepSignedIn || undefined;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._identityProvider.getGuestFromTokenAsync(keepSignedIn || false, refreshToken, idToken)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        _a = _b.sent();
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AccountManager.prototype.fireGuestRequiredEventAsync = function() {
        return $96201fd4d61290bf$var$__awaiter(this, void 0, void 0, function() {
            var listenerIterator, next, guest;
            return $96201fd4d61290bf$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        listenerIterator = this._registeredEvents[$96201fd4d61290bf$export$4b5e90bac1c21735.GuestRequired].values();
                        next = listenerIterator.next();
                        _a.label = 1;
                    case 1:
                        if (!!next.done) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            next.value()
                        ];
                    case 2:
                        guest = _a.sent();
                        if (guest) return [
                            2 /*return*/ ,
                            guest
                        ];
                        next = listenerIterator.next();
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                }
            });
        });
    };
    AccountManager.prototype.fireLoggedInEvent = function(guest) {
        var listeners = Array.from(this._registeredEvents[$96201fd4d61290bf$export$4b5e90bac1c21735.LoggedIn].values());
        return listeners.forEach(function(listener) {
            return listener(guest);
        });
    };
    AccountManager.prototype.fireLoggedOutEvent = function() {
        var listeners = Array.from(this._registeredEvents[$96201fd4d61290bf$export$4b5e90bac1c21735.LoggedOut].values());
        return listeners.forEach(function(listener) {
            return listener();
        });
    };
    AccountManager.prototype.getEventSet = function(event) {
        // We are using `as` keyword here because TS still not able to
        // validate generics properly https://github.com/microsoft/TypeScript/issues/24085
        return this._registeredEvents[event];
    };
    return AccountManager;
}();
var $96201fd4d61290bf$var$currentManager = new $96201fd4d61290bf$export$a1e1c1cb52ebd7df((0, $33R1Y.IdentityProvider).current);

});
parcelRegister("7BrIz", function(module, exports) {

$parcel$export(module.exports, "MILLISECONDS_PER_SECOND", function () { return $58917d4e709daadf$export$158bbc173906b542; });
$parcel$export(module.exports, "MILLISECONDS_PER_MINUTE", function () { return $58917d4e709daadf$export$9245831f62081b68; });
$parcel$export(module.exports, "dateFromTotalSeconds", function () { return $58917d4e709daadf$export$594b5006c3d01ee; });
var $58917d4e709daadf$export$158bbc173906b542 = 1000;
var $58917d4e709daadf$export$9245831f62081b68 = 60000;
var $58917d4e709daadf$export$594b5006c3d01ee = function(totalSeconds) {
    return new Date(totalSeconds * $58917d4e709daadf$export$158bbc173906b542);
};

});

parcelRegister("8jIBp", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedError", function () { return $60e2b227bd9b8b28$export$8a9c04b0629a0419; });
var $60e2b227bd9b8b28$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $60e2b227bd9b8b28$export$8a9c04b0629a0419 = /** @class */ function(_super) {
    $60e2b227bd9b8b28$var$__extends(UnauthorizedError, _super);
    function UnauthorizedError(message) {
        var _this = _super.call(this, message) || this;
        // Set the prototype explicitly.
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, UnauthorizedError.prototype);
        return _this;
    }
    return UnauthorizedError;
}(Error);

});

parcelRegister("33R1Y", function(module, exports) {

$parcel$export(module.exports, "OtpType", function () { return $23aac9b8bce699ff$export$269e322b26c5004; });
$parcel$export(module.exports, "IdentityProvider", function () { return $23aac9b8bce699ff$export$26106abfb5b2a456; });

var $gau1J = parcelRequire("gau1J");

var $7BrIz = parcelRequire("7BrIz");

var $03ABY = parcelRequire("03ABY");

var $3lWib = parcelRequire("3lWib");

var $h23aJ = parcelRequire("h23aJ");

var $2oFxA = parcelRequire("2oFxA");

var $aekix = parcelRequire("aekix");

var $1Newx = parcelRequire("1Newx");
var $23aac9b8bce699ff$var$__assign = undefined && undefined.__assign || function() {
    $23aac9b8bce699ff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23aac9b8bce699ff$var$__assign.apply(this, arguments);
};
var $23aac9b8bce699ff$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $23aac9b8bce699ff$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * Amount of minutes when it is better to request a new token using refresh token for UX
 */ var $23aac9b8bce699ff$var$ALMOST_INVALID_TOKEN_MINUTES = 3;
var $23aac9b8bce699ff$var$ForgerockTokenType;
(function(ForgerockTokenType) {
    ForgerockTokenType["JWTToken"] = "JWTToken";
    ForgerockTokenType["Bearer"] = "Bearer";
})($23aac9b8bce699ff$var$ForgerockTokenType || ($23aac9b8bce699ff$var$ForgerockTokenType = {}));
var $23aac9b8bce699ff$export$c56e9f277732b17e;
(function(ForgerockTokenName) {
    ForgerockTokenName["RefreshToken"] = "refresh_token";
    ForgerockTokenName["IdToken"] = "id_token";
})($23aac9b8bce699ff$export$c56e9f277732b17e || ($23aac9b8bce699ff$export$c56e9f277732b17e = {}));
var $23aac9b8bce699ff$export$269e322b26c5004;
(function(OtpType) {
    OtpType[OtpType["Registration"] = 0] = "Registration";
    OtpType[OtpType["Other"] = 1] = "Other";
})($23aac9b8bce699ff$export$269e322b26c5004 || ($23aac9b8bce699ff$export$269e322b26c5004 = {}));
var $23aac9b8bce699ff$var$isErrorResponse = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "error" in value && typeof value.error === "string";
};
var $23aac9b8bce699ff$var$isLoginResponse = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "id_token" in value && typeof value.id_token === "string" && "refresh_token" in value && typeof value.refresh_token === "string" && "expires_in" in value && (typeof value.expires_in === "string" || typeof value.expires_in === "number");
};
var $23aac9b8bce699ff$var$isMessageResponse = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "messages" in value && Array.isArray(value.messages) && value.messages.every(function(message) {
        return typeof message === "string" && (0, $03ABY.AuthenticationErrorType)[message] !== undefined;
    }) && (!("authId" in value) || typeof value.authId === "string");
};
var $23aac9b8bce699ff$var$isAuthIdResponse = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "authId" in value && typeof value.authId === "string";
};
var $23aac9b8bce699ff$var$isGuestDetailsResponse = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "accountId" in value && typeof value.accountId === "string";
};
var $23aac9b8bce699ff$var$loginResponseValidator = function(value) {
    return $23aac9b8bce699ff$var$isLoginResponse(value) || $23aac9b8bce699ff$var$isMessageResponse(value) || $23aac9b8bce699ff$var$isErrorResponse(value);
};
var $23aac9b8bce699ff$var$otpResponseValidator = function(value) {
    return $23aac9b8bce699ff$var$isLoginResponse(value) || $23aac9b8bce699ff$var$isAuthIdResponse(value) || $23aac9b8bce699ff$var$isMessageResponse(value) || $23aac9b8bce699ff$var$isErrorResponse(value);
};
var $23aac9b8bce699ff$var$registrationResponseValidator = function(value) {
    return $23aac9b8bce699ff$var$isMessageResponse(value) || $23aac9b8bce699ff$var$isErrorResponse(value);
};
var $23aac9b8bce699ff$var$resendOtpResponseValidator = function(value) {
    return $23aac9b8bce699ff$var$isAuthIdResponse(value) || $23aac9b8bce699ff$var$isMessageResponse(value) || $23aac9b8bce699ff$var$isErrorResponse(value);
};
var $23aac9b8bce699ff$var$resetResponseValidator = function(value) {
    return $23aac9b8bce699ff$var$isMessageResponse(value) || $23aac9b8bce699ff$var$isErrorResponse(value);
};
var $23aac9b8bce699ff$var$isSalesforceErrorResponse = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "errorCode" in value && typeof value.errorCode === "string" && (!("caseNumber" in value) || typeof value.caseNumber === "string");
};
var $23aac9b8bce699ff$var$registerGuestResponseValidator = function(value) {
    return $23aac9b8bce699ff$var$isGuestDetailsResponse(value) || $23aac9b8bce699ff$var$isSalesforceErrorResponse(value) || $23aac9b8bce699ff$var$isErrorResponse(value);
};
var $23aac9b8bce699ff$var$isValidIdTokenValue = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "tokenName" in value && value.tokenName === $23aac9b8bce699ff$export$c56e9f277732b17e.IdToken && "name" in value && typeof value.name === "string" && "given_name" in value && typeof value.given_name === "string" && "family_name" in value && typeof value.family_name === "string" && "email" in value && typeof value.email === "string" && "phone_number" in value && typeof value.phone_number === "string" && "exp" in value && typeof value.exp === "number";
};
var $23aac9b8bce699ff$var$isValidRefreshTokenValue = function(value) {
    return (0, $1Newx.isDefinedUnknownObject)(value) && "tokenName" in value && value.tokenName === $23aac9b8bce699ff$export$c56e9f277732b17e.RefreshToken && "exp" in value && typeof value.exp === "number";
};
var $23aac9b8bce699ff$var$JWT_PARTS_COUNT = 3;
/**
 * Contains functions required for guests authentication.
 * This class is designed to be used as singleton (@see IdentityProvider.current.<...>) unless you need to
 * have many instances with different @see IdentityProviderProps
 */ var $23aac9b8bce699ff$export$26106abfb5b2a456 = /** @class */ function() {
    function IdentityProvider() {
        var _this = this;
        this._propsAwaitingQueue = new Set();
        this.updateGuestDetailsAsync = function(idToken, guestDetailsToUpdate) {
            return $23aac9b8bce699ff$var$__awaiter(_this, void 0, Promise, function() {
                var props, token, isDemoUser, result, response;
                var _a;
                return $23aac9b8bce699ff$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getPropsAsync()
                            ];
                        case 1:
                            props = _b.sent();
                            token = IdentityProvider.getInfoFromToken(idToken);
                            isDemoUser = token && ((_a = token.isDemoUser) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true";
                            if (!(isDemoUser && props.guestServiceDemoUrl)) return [
                                3 /*break*/ ,
                                4
                            ];
                            return [
                                4 /*yield*/ ,
                                fetch(props.guestServiceDemoUrl, {})
                            ];
                        case 2:
                            response = _b.sent();
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 3:
                            result = _b.sent();
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                this.postRequestAsync(props.guestServiceUrl, $23aac9b8bce699ff$var$registerGuestResponseValidator, guestDetailsToUpdate, idToken)
                            ];
                        case 5:
                            result = _b.sent();
                            _b.label = 6;
                        case 6:
                            if ($23aac9b8bce699ff$var$isGuestDetailsResponse(result)) return [
                                2 /*return*/ ,
                                result
                            ];
                            if ($23aac9b8bce699ff$var$isSalesforceErrorResponse(result)) throw new (0, $2oFxA.SalesforceError)(result.errorCode, result.caseNumber);
                            throw this.getGenericError(result);
                    }
                });
            });
        };
    }
    Object.defineProperty(IdentityProvider, "current", {
        get: function() {
            return $23aac9b8bce699ff$var$currentIdentityProvider;
        },
        enumerable: false,
        configurable: true
    });
    IdentityProvider.prototype.init = function(props) {
        this._props = $23aac9b8bce699ff$var$__assign({}, props);
        var resolvers = Array.from(this._propsAwaitingQueue);
        for(var _i = 0, resolvers_1 = resolvers; _i < resolvers_1.length; _i++){
            var resolver = resolvers_1[_i];
            resolver(this._props);
        }
        this._propsAwaitingQueue.clear();
    };
    IdentityProvider.prototype.postRequestAsync = function(url, validator, body, idToken) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $gau1J.typedFetch)(url, validator, {
                                mode: "cors",
                                headers: $23aac9b8bce699ff$var$__assign({
                                    "Content-Type": "application/json"
                                }, idToken ? {
                                    Authorization: "Bearer ".concat(idToken)
                                } : {}),
                                method: "POST",
                                body: JSON.stringify(body)
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            response.json()
                        ];
                }
            });
        });
    };
    IdentityProvider.prototype.loginAsync = function(keepSignedIn, email, password, newPhoneNumber, newPassword) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/login");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$loginResponseValidator, {
                                username: email,
                                password: password,
                                newPhoneNumber: newPhoneNumber,
                                newPassword: newPassword
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isLoginResponse(result)) return [
                            2 /*return*/ ,
                            this.getGuestFromLoginResponse(keepSignedIn, result)
                        ];
                        if ($23aac9b8bce699ff$var$isMessageResponse(result)) throw new (0, $03ABY.AuthenticationError)(new Set(result.messages), result.authId || undefined);
                        throw this.getGenericError(result);
                }
            });
        });
    };
    IdentityProvider.prototype.requestOtpAsync = function(authId, requestType) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/resend-otp");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$resendOtpResponseValidator, {
                                authId: authId,
                                requestType: requestType
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isAuthIdResponse(result)) return [
                            2 /*return*/ ,
                            result.authId
                        ];
                        if ($23aac9b8bce699ff$var$isMessageResponse(result)) throw new (0, $03ABY.AuthenticationError)(new Set(result.messages), result.authId || undefined);
                        throw this.getGenericError(result);
                }
            });
        });
    };
    /**
     * Returns AuthId or error.
     */ IdentityProvider.prototype.resetPasswordAsync = function(email) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/reset-password");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$resetResponseValidator, {
                                username: email
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isMessageResponse(result)) {
                            if (result.messages.length === 1 && result.messages[0] === (0, $03ABY.AuthenticationErrorType).OtpCodeRequired && result.authId) return [
                                2 /*return*/ ,
                                result.authId
                            ];
                            throw new (0, $03ABY.AuthenticationError)(new Set(result.messages), result.authId || undefined);
                        }
                        throw this.getGenericError(result);
                }
            });
        });
    };
    IdentityProvider.prototype.registerAsync = function(email, password, mobileNumber, firstName, lastName) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/register");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$registrationResponseValidator, {
                                email: email,
                                password: password,
                                mobileNumber: mobileNumber,
                                firstName: firstName,
                                lastName: lastName
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isMessageResponse(result)) throw new (0, $03ABY.AuthenticationError)(new Set(result.messages), result.authId || undefined);
                        throw this.getGenericError(result);
                }
            });
        });
    };
    IdentityProvider.prototype.submitOtpAsync = function(keepSignedIn, authId, code, otpType) {
        if (otpType === void 0) otpType = $23aac9b8bce699ff$export$269e322b26c5004.Registration;
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/validate-otp");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$otpResponseValidator, {
                                authId: authId,
                                code: code,
                                otpType: otpType
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isLoginResponse(result)) return [
                            2 /*return*/ ,
                            this.getGuestFromLoginResponse(keepSignedIn, result)
                        ];
                        if ($23aac9b8bce699ff$var$isAuthIdResponse(result)) return [
                            2 /*return*/ ,
                            result.authId
                        ];
                        if ($23aac9b8bce699ff$var$isMessageResponse(result)) throw new (0, $03ABY.AuthenticationError)(new Set(result.messages), result.authId || undefined);
                        throw this.getGenericError(result);
                }
            });
        });
    };
    IdentityProvider.prototype.setNewPasswordAsync = function(authId, password, keepSignedIn) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/submit-password");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$loginResponseValidator, {
                                authId: authId,
                                password: password
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isLoginResponse(result)) return [
                            2 /*return*/ ,
                            this.getGuestFromLoginResponse(keepSignedIn, result)
                        ];
                        if ($23aac9b8bce699ff$var$isMessageResponse(result)) throw new (0, $03ABY.AuthenticationError)(new Set(result.messages), result.authId || undefined);
                        throw this.getGenericError(result);
                }
            });
        });
    };
    /**
     * Should be used only for migration flow.
     * This method only throws specific result and you need to handle
     * messages from @see AuthenticationError
     */ IdentityProvider.prototype.saveNewPasswordAsync = function(email, password, mobileNumber) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/save-password");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$registrationResponseValidator, {
                                email: email,
                                password: password,
                                mobileNumber: mobileNumber
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isMessageResponse(result)) throw new (0, $03ABY.AuthenticationError)(new Set(result.messages), result.authId || undefined);
                        throw this.getGenericError(result);
                }
            });
        });
    };
    IdentityProvider.prototype.getGuestFromTokenAsync = function(keepSignedIn, refreshToken, idToken) {
        return $23aac9b8bce699ff$var$__awaiter(this, void 0, Promise, function() {
            var token, props, url, result;
            return $23aac9b8bce699ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        token = IdentityProvider.getInfoFromToken(idToken);
                        if ((token === null || token === void 0 ? void 0 : token.tokenName) === $23aac9b8bce699ff$export$c56e9f277732b17e.IdToken && idToken) {
                            if (!IdentityProvider.isTokenExpired(token)) // Just using existing tokens
                            try {
                                return [
                                    2 /*return*/ ,
                                    new (0, $h23aJ.Guest)(token.email, idToken, refreshToken, (0, $3lWib.GuestAccountType).Default, keepSignedIn, this.updateGuestDetailsAsync)
                                ];
                            } catch (_b) {
                                return [
                                    2 /*return*/ ,
                                    undefined
                                ];
                            }
                        }
                        if (!refreshToken) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getPropsAsync()
                        ];
                    case 1:
                        props = _a.sent();
                        url = "".concat(props.guestServiceUrl, "/refresh-token");
                        return [
                            4 /*yield*/ ,
                            this.postRequestAsync(url, $23aac9b8bce699ff$var$loginResponseValidator, {
                                refreshToken: refreshToken
                            })
                        ];
                    case 2:
                        result = _a.sent();
                        if ($23aac9b8bce699ff$var$isLoginResponse(result)) return [
                            2 /*return*/ ,
                            this.getGuestFromLoginResponse(keepSignedIn, result)
                        ];
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                }
            });
        });
    };
    IdentityProvider.prototype.getGuestFromLoginResponse = function(keepSignedIn, result) {
        var token = IdentityProvider.getInfoFromToken(result.id_token);
        var email = (token === null || token === void 0 ? void 0 : token.tokenName) === $23aac9b8bce699ff$export$c56e9f277732b17e.IdToken ? token.email : undefined;
        if (!email) throw new Error("Invalid ID token");
        return new (0, $h23aJ.Guest)(email, result.id_token, result.refresh_token, (0, $3lWib.GuestAccountType).Default, keepSignedIn, this.updateGuestDetailsAsync);
    };
    IdentityProvider.prototype.getGenericError = function(result) {
        return new Error($23aac9b8bce699ff$var$isErrorResponse(result) ? result.error || result.error_description : undefined);
    };
    IdentityProvider.prototype.getPropsAsync = function() {
        var _this = this;
        return this._props ? Promise.resolve(this._props) : new Promise(function(resolve) {
            _this._propsAwaitingQueue.add(resolve);
        });
    };
    IdentityProvider.getInfoFromToken = function(jwToken) {
        var parts = jwToken === null || jwToken === void 0 ? void 0 : jwToken.split(".");
        if ((parts === null || parts === void 0 ? void 0 : parts.length) !== $23aac9b8bce699ff$var$JWT_PARTS_COUNT || !parts[1].length) return undefined;
        var values = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($aekix))).decode(parts[1]));
        return $23aac9b8bce699ff$var$isValidIdTokenValue(values) || $23aac9b8bce699ff$var$isValidRefreshTokenValue(values) ? values : undefined;
    };
    IdentityProvider.isTokenExpired = function(token) {
        if (!(token === null || token === void 0 ? void 0 : token.exp)) return true;
        var expireOn = (0, $7BrIz.dateFromTotalSeconds)(token.exp);
        return (expireOn.getTime() - new Date().getTime()) / (0, $7BrIz.MILLISECONDS_PER_MINUTE) < $23aac9b8bce699ff$var$ALMOST_INVALID_TOKEN_MINUTES;
    };
    return IdentityProvider;
}();
var $23aac9b8bce699ff$var$currentIdentityProvider = new $23aac9b8bce699ff$export$26106abfb5b2a456();

});
parcelRegister("gau1J", function(module, exports) {

$parcel$export(module.exports, "typedFetch", function () { return $bc54df36f80d2eb5$export$6681d9610001133e; });
var $bc54df36f80d2eb5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bc54df36f80d2eb5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $bc54df36f80d2eb5$export$6681d9610001133e = function(input, validator, init) {
    return $bc54df36f80d2eb5$var$__awaiter(void 0, void 0, Promise, function() {
        var response, jsonValue, _a, handler;
        return $bc54df36f80d2eb5$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        fetch(input, init)
                    ];
                case 1:
                    response = _b.sent();
                    if (!(response.body !== null)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 2:
                    _a = _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    _a = null;
                    _b.label = 4;
                case 4:
                    jsonValue = _a;
                    if (validator(jsonValue)) {
                        handler = {
                            get: function(target, prop, receiver) {
                                return prop === "json" ? function() {
                                    return Promise.resolve(jsonValue);
                                } : Reflect.get(target, prop, receiver);
                            }
                        };
                        return [
                            2 /*return*/ ,
                            new Proxy(response, handler)
                        ];
                    } else {
                        // eslint-disable-next-line no-console
                        console.error("Invalid response type", jsonValue);
                        throw new Error("Invalid response type");
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};

});

parcelRegister("03ABY", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorType", function () { return $00acae3b9281db4d$export$b46747140e3cf7db; });
$parcel$export(module.exports, "AuthenticationError", function () { return $00acae3b9281db4d$export$cf0c46b07324e9c5; });
var $00acae3b9281db4d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $00acae3b9281db4d$export$b46747140e3cf7db;
(function(AuthenticationErrorType) {
    AuthenticationErrorType["PhoneNotUnique"] = "PhoneNotUnique";
    AuthenticationErrorType["PhoneMissing"] = "PhoneMissing";
    AuthenticationErrorType["PhoneInvalid"] = "PhoneInvalid";
    AuthenticationErrorType["PasswordInvalid"] = "PasswordInvalid";
    AuthenticationErrorType["NewPasswordInvalid"] = "NewPasswordInvalid";
    AuthenticationErrorType["PasswordIsTheSame"] = "PasswordIsTheSame";
    AuthenticationErrorType["PasswordNotMatchingPolicy"] = "PasswordNotMatchingPolicy";
    AuthenticationErrorType["UserNotFound"] = "UserNotFound";
    AuthenticationErrorType["UserExists"] = "UserExists";
    AuthenticationErrorType["OtpCodeRequired"] = "OtpCodeRequired";
    AuthenticationErrorType["OtpInvalid"] = "OtpInvalid";
    AuthenticationErrorType["EmailNotUnique"] = "EmailNotUnique";
    AuthenticationErrorType["EmailInvalid"] = "EmailInvalid";
    AuthenticationErrorType["TnCsInvalid"] = "TnCsInvalid";
    AuthenticationErrorType["InvalidInput"] = "InvalidInput";
    AuthenticationErrorType["AccountLocked"] = "AccountLocked";
    AuthenticationErrorType["SessionTimeout"] = "SessionTimeout";
})($00acae3b9281db4d$export$b46747140e3cf7db || ($00acae3b9281db4d$export$b46747140e3cf7db = {}));
var $00acae3b9281db4d$export$cf0c46b07324e9c5 = /** @class */ function(_super) {
    $00acae3b9281db4d$var$__extends(AuthenticationError, _super);
    function AuthenticationError(types, authId) {
        var _this = _super.call(this, Array.from(types).join(" \n")) || this;
        _this._types = types;
        _this._authId = authId;
        // Set the prototype explicitly.
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, AuthenticationError.prototype);
        return _this;
    }
    AuthenticationError.prototype.hasType = function(type) {
        return this._types.has(type);
    };
    AuthenticationError.prototype.hasAnyType = function(types) {
        var _this = this;
        return types.some(function(type) {
            return _this._types.has(type);
        });
    };
    Object.defineProperty(AuthenticationError.prototype, "types", {
        get: function() {
            return this._types;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthenticationError.prototype, "authId", {
        get: function() {
            return this._authId;
        },
        enumerable: false,
        configurable: true
    });
    return AuthenticationError;
}(Error);

});

parcelRegister("3lWib", function(module, exports) {

$parcel$export(module.exports, "GuestAccountType", function () { return $27108ce1db3e5b91$export$d636a614e28bf136; });
var $27108ce1db3e5b91$export$d636a614e28bf136;
(function(GuestAccountType) {
    GuestAccountType[GuestAccountType["Default"] = 1] = "Default";
    GuestAccountType[GuestAccountType["Social"] = 2] = "Social";
})($27108ce1db3e5b91$export$d636a614e28bf136 || ($27108ce1db3e5b91$export$d636a614e28bf136 = {}));

});

parcelRegister("h23aJ", function(module, exports) {

$parcel$export(module.exports, "Guest", function () { return $c665157edbff7bf5$export$8f34b4a435d210a1; });
var $c665157edbff7bf5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c665157edbff7bf5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c665157edbff7bf5$export$8f34b4a435d210a1 = /** @class */ function() {
    function Guest(email, idToken, refreshToken, type, keepSignedIn, getOrUpdateDetailsAsync) {
        var _this = this;
        /**
         * Updates guest details and return the latest values. If @param detailsToUpdate is not defined
         * the details may be returned from cache, to avoid cache pass empty object for @param detailsToUpdate
         */ this.getOrUpdateDetailsAsync = function(detailsToUpdate) {
            return $c665157edbff7bf5$var$__awaiter(_this, void 0, Promise, function() {
                var _a;
                return $c665157edbff7bf5$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(detailsToUpdate || !this._cachedDetails)) return [
                                3 /*break*/ ,
                                2
                            ];
                            _a = this;
                            return [
                                4 /*yield*/ ,
                                this._getOrUpdateDetailsAsync(this.idToken, detailsToUpdate !== null && detailsToUpdate !== void 0 ? detailsToUpdate : {})
                            ];
                        case 1:
                            _a._cachedDetails = _b.sent();
                            _b.label = 2;
                        case 2:
                            return [
                                2 /*return*/ ,
                                this._cachedDetails
                            ];
                    }
                });
            });
        };
        this._email = email;
        this._idToken = idToken;
        this._refreshToken = refreshToken;
        this._type = type;
        this._keepSignedIn = keepSignedIn;
        this._getOrUpdateDetailsAsync = getOrUpdateDetailsAsync;
    }
    Object.defineProperty(Guest.prototype, "email", {
        get: function() {
            return this._email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Guest.prototype, "idToken", {
        get: function() {
            return this._idToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Guest.prototype, "refreshToken", {
        get: function() {
            return this._refreshToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Guest.prototype, "type", {
        get: function() {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Guest.prototype, "keepSignedIn", {
        get: function() {
            return this._keepSignedIn;
        },
        enumerable: false,
        configurable: true
    });
    return Guest;
}();

});

parcelRegister("2oFxA", function(module, exports) {

$parcel$export(module.exports, "SalesforceError", function () { return $1bee0bc2daf59620$export$bac683ba69b3f67f; });
var $1bee0bc2daf59620$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1bee0bc2daf59620$export$bac683ba69b3f67f = /** @class */ function(_super) {
    $1bee0bc2daf59620$var$__extends(SalesforceError, _super);
    function SalesforceError(errorCode, caseNumber) {
        var _this = _super.call(this, errorCode) || this;
        _this._errorCode = errorCode;
        _this._caseNumber = caseNumber;
        // Set the prototype explicitly.
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, SalesforceError.prototype);
        return _this;
    }
    Object.defineProperty(SalesforceError.prototype, "errorCode", {
        get: function() {
            return this._errorCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SalesforceError.prototype, "caseNumber", {
        get: function() {
            return this._caseNumber;
        },
        enumerable: false,
        configurable: true
    });
    return SalesforceError;
}(Error);

});

parcelRegister("aekix", function(module, exports) {

module.exports = (parcelRequire("bECtT")).default;
module.exports.default = module.exports;

});
parcelRegister("bECtT", function(module, exports) {

var $4lZp4 = parcelRequire("4lZp4");
var $87c147b19bc8d4d6$require$Buffer = $4lZp4.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Mjji = parcelRequire("5Mjji");
function $87c147b19bc8d4d6$var$encode(input, encoding) {
    if (encoding === void 0) encoding = "utf8";
    if ($87c147b19bc8d4d6$require$Buffer.isBuffer(input)) return $87c147b19bc8d4d6$var$fromBase64(input.toString("base64"));
    return $87c147b19bc8d4d6$var$fromBase64($87c147b19bc8d4d6$require$Buffer.from(input, encoding).toString("base64"));
}
function $87c147b19bc8d4d6$var$decode(base64url, encoding) {
    if (encoding === void 0) encoding = "utf8";
    return $87c147b19bc8d4d6$require$Buffer.from($87c147b19bc8d4d6$var$toBase64(base64url), "base64").toString(encoding);
}
function $87c147b19bc8d4d6$var$toBase64(base64url) {
    base64url = base64url.toString();
    return $5Mjji.default(base64url).replace(/\-/g, "+").replace(/_/g, "/");
}
function $87c147b19bc8d4d6$var$fromBase64(base64) {
    return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $87c147b19bc8d4d6$var$toBuffer(base64url) {
    return $87c147b19bc8d4d6$require$Buffer.from($87c147b19bc8d4d6$var$toBase64(base64url), "base64");
}
var $87c147b19bc8d4d6$var$base64url = $87c147b19bc8d4d6$var$encode;
$87c147b19bc8d4d6$var$base64url.encode = $87c147b19bc8d4d6$var$encode;
$87c147b19bc8d4d6$var$base64url.decode = $87c147b19bc8d4d6$var$decode;
$87c147b19bc8d4d6$var$base64url.toBase64 = $87c147b19bc8d4d6$var$toBase64;
$87c147b19bc8d4d6$var$base64url.fromBase64 = $87c147b19bc8d4d6$var$fromBase64;
$87c147b19bc8d4d6$var$base64url.toBuffer = $87c147b19bc8d4d6$var$toBuffer;
module.exports.default = $87c147b19bc8d4d6$var$base64url;

});
parcelRegister("4lZp4", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $32b8c10976407601$export$a143d493d941bafc; }, function (v) { return $32b8c10976407601$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $32b8c10976407601$export$f99ded8fe4b79145; }, function (v) { return $32b8c10976407601$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $32b8c10976407601$export$a143d493d941bafc;
var $32b8c10976407601$export$e4cf37d7f6fb9e0a;
var $32b8c10976407601$export$f99ded8fe4b79145;
var $32b8c10976407601$export$599f31c3813fae4d;
"use strict";

var $6WdfO = parcelRequire("6WdfO");

var $24dbd = parcelRequire("24dbd");
var $32b8c10976407601$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$32b8c10976407601$export$a143d493d941bafc = $32b8c10976407601$var$Buffer;
$32b8c10976407601$export$e4cf37d7f6fb9e0a = $32b8c10976407601$var$SlowBuffer;
$32b8c10976407601$export$f99ded8fe4b79145 = 50;
var $32b8c10976407601$var$K_MAX_LENGTH = 0x7fffffff;
$32b8c10976407601$export$599f31c3813fae4d = $32b8c10976407601$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $32b8c10976407601$var$Buffer.TYPED_ARRAY_SUPPORT = $32b8c10976407601$var$typedArraySupport();
if (!$32b8c10976407601$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $32b8c10976407601$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($32b8c10976407601$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$32b8c10976407601$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($32b8c10976407601$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$32b8c10976407601$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $32b8c10976407601$var$createBuffer(length) {
    if (length > $32b8c10976407601$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $32b8c10976407601$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $32b8c10976407601$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $32b8c10976407601$var$allocUnsafe(arg);
    }
    return $32b8c10976407601$var$from(arg, encodingOrOffset, length);
}
$32b8c10976407601$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $32b8c10976407601$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $32b8c10976407601$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $32b8c10976407601$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($32b8c10976407601$var$isInstance(value, ArrayBuffer) || value && $32b8c10976407601$var$isInstance(value.buffer, ArrayBuffer)) return $32b8c10976407601$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($32b8c10976407601$var$isInstance(value, SharedArrayBuffer) || value && $32b8c10976407601$var$isInstance(value.buffer, SharedArrayBuffer))) return $32b8c10976407601$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $32b8c10976407601$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $32b8c10976407601$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $32b8c10976407601$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $32b8c10976407601$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $32b8c10976407601$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($32b8c10976407601$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($32b8c10976407601$var$Buffer, Uint8Array);
function $32b8c10976407601$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $32b8c10976407601$var$alloc(size, fill, encoding) {
    $32b8c10976407601$var$assertSize(size);
    if (size <= 0) return $32b8c10976407601$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $32b8c10976407601$var$createBuffer(size).fill(fill, encoding) : $32b8c10976407601$var$createBuffer(size).fill(fill);
    return $32b8c10976407601$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $32b8c10976407601$var$Buffer.alloc = function(size, fill, encoding) {
    return $32b8c10976407601$var$alloc(size, fill, encoding);
};
function $32b8c10976407601$var$allocUnsafe(size) {
    $32b8c10976407601$var$assertSize(size);
    return $32b8c10976407601$var$createBuffer(size < 0 ? 0 : $32b8c10976407601$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $32b8c10976407601$var$Buffer.allocUnsafe = function(size) {
    return $32b8c10976407601$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $32b8c10976407601$var$Buffer.allocUnsafeSlow = function(size) {
    return $32b8c10976407601$var$allocUnsafe(size);
};
function $32b8c10976407601$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$32b8c10976407601$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $32b8c10976407601$var$byteLength(string, encoding) | 0;
    var buf = $32b8c10976407601$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $32b8c10976407601$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $32b8c10976407601$var$checked(array.length) | 0;
    var buf = $32b8c10976407601$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $32b8c10976407601$var$fromArrayView(arrayView) {
    if ($32b8c10976407601$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $32b8c10976407601$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $32b8c10976407601$var$fromArrayLike(arrayView);
}
function $32b8c10976407601$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $32b8c10976407601$var$Buffer.prototype);
    return buf;
}
function $32b8c10976407601$var$fromObject(obj) {
    if ($32b8c10976407601$var$Buffer.isBuffer(obj)) {
        var len = $32b8c10976407601$var$checked(obj.length) | 0;
        var buf = $32b8c10976407601$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $32b8c10976407601$var$numberIsNaN(obj.length)) return $32b8c10976407601$var$createBuffer(0);
        return $32b8c10976407601$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $32b8c10976407601$var$fromArrayLike(obj.data);
}
function $32b8c10976407601$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $32b8c10976407601$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $32b8c10976407601$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $32b8c10976407601$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $32b8c10976407601$var$Buffer.alloc(+length);
}
$32b8c10976407601$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $32b8c10976407601$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$32b8c10976407601$var$Buffer.compare = function compare(a, b) {
    if ($32b8c10976407601$var$isInstance(a, Uint8Array)) a = $32b8c10976407601$var$Buffer.from(a, a.offset, a.byteLength);
    if ($32b8c10976407601$var$isInstance(b, Uint8Array)) b = $32b8c10976407601$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$32b8c10976407601$var$Buffer.isBuffer(a) || !$32b8c10976407601$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$32b8c10976407601$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$32b8c10976407601$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $32b8c10976407601$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $32b8c10976407601$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($32b8c10976407601$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $32b8c10976407601$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$32b8c10976407601$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $32b8c10976407601$var$byteLength(string, encoding) {
    if ($32b8c10976407601$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $32b8c10976407601$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $32b8c10976407601$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $32b8c10976407601$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $32b8c10976407601$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$32b8c10976407601$var$Buffer.byteLength = $32b8c10976407601$var$byteLength;
function $32b8c10976407601$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $32b8c10976407601$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $32b8c10976407601$var$utf8Slice(this, start, end);
        case "ascii":
            return $32b8c10976407601$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $32b8c10976407601$var$latin1Slice(this, start, end);
        case "base64":
            return $32b8c10976407601$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $32b8c10976407601$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$32b8c10976407601$var$Buffer.prototype._isBuffer = true;
function $32b8c10976407601$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$32b8c10976407601$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$32b8c10976407601$var$swap(this, i, i + 1);
    return this;
};
$32b8c10976407601$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $32b8c10976407601$var$swap(this, i, i + 3);
        $32b8c10976407601$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$32b8c10976407601$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $32b8c10976407601$var$swap(this, i, i + 7);
        $32b8c10976407601$var$swap(this, i + 1, i + 6);
        $32b8c10976407601$var$swap(this, i + 2, i + 5);
        $32b8c10976407601$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$32b8c10976407601$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $32b8c10976407601$var$utf8Slice(this, 0, length);
    return $32b8c10976407601$var$slowToString.apply(this, arguments);
};
$32b8c10976407601$var$Buffer.prototype.toLocaleString = $32b8c10976407601$var$Buffer.prototype.toString;
$32b8c10976407601$var$Buffer.prototype.equals = function equals(b) {
    if (!$32b8c10976407601$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $32b8c10976407601$var$Buffer.compare(this, b) === 0;
};
$32b8c10976407601$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $32b8c10976407601$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($32b8c10976407601$var$customInspectSymbol) $32b8c10976407601$var$Buffer.prototype[$32b8c10976407601$var$customInspectSymbol] = $32b8c10976407601$var$Buffer.prototype.inspect;
$32b8c10976407601$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($32b8c10976407601$var$isInstance(target, Uint8Array)) target = $32b8c10976407601$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$32b8c10976407601$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $32b8c10976407601$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($32b8c10976407601$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $32b8c10976407601$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($32b8c10976407601$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $32b8c10976407601$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $32b8c10976407601$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $32b8c10976407601$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$32b8c10976407601$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$32b8c10976407601$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $32b8c10976407601$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$32b8c10976407601$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $32b8c10976407601$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $32b8c10976407601$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($32b8c10976407601$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $32b8c10976407601$var$utf8Write(buf, string, offset, length) {
    return $32b8c10976407601$var$blitBuffer($32b8c10976407601$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $32b8c10976407601$var$asciiWrite(buf, string, offset, length) {
    return $32b8c10976407601$var$blitBuffer($32b8c10976407601$var$asciiToBytes(string), buf, offset, length);
}
function $32b8c10976407601$var$base64Write(buf, string, offset, length) {
    return $32b8c10976407601$var$blitBuffer($32b8c10976407601$var$base64ToBytes(string), buf, offset, length);
}
function $32b8c10976407601$var$ucs2Write(buf, string, offset, length) {
    return $32b8c10976407601$var$blitBuffer($32b8c10976407601$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$32b8c10976407601$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $32b8c10976407601$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $32b8c10976407601$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $32b8c10976407601$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $32b8c10976407601$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $32b8c10976407601$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$32b8c10976407601$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $32b8c10976407601$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6WdfO.fromByteArray(buf);
    else return $6WdfO.fromByteArray(buf.slice(start, end));
}
function $32b8c10976407601$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $32b8c10976407601$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $32b8c10976407601$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $32b8c10976407601$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $32b8c10976407601$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $32b8c10976407601$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $32b8c10976407601$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $32b8c10976407601$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $32b8c10976407601$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $32b8c10976407601$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $32b8c10976407601$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$32b8c10976407601$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $32b8c10976407601$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $32b8c10976407601$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$32b8c10976407601$var$Buffer.prototype.readUintLE = $32b8c10976407601$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$32b8c10976407601$var$Buffer.prototype.readUintBE = $32b8c10976407601$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$32b8c10976407601$var$Buffer.prototype.readUint8 = $32b8c10976407601$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$32b8c10976407601$var$Buffer.prototype.readUint16LE = $32b8c10976407601$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$32b8c10976407601$var$Buffer.prototype.readUint16BE = $32b8c10976407601$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$32b8c10976407601$var$Buffer.prototype.readUint32LE = $32b8c10976407601$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$32b8c10976407601$var$Buffer.prototype.readUint32BE = $32b8c10976407601$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$32b8c10976407601$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$32b8c10976407601$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$32b8c10976407601$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$32b8c10976407601$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$32b8c10976407601$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$32b8c10976407601$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$32b8c10976407601$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$32b8c10976407601$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 4, this.length);
    return $24dbd.read(this, offset, true, 23, 4);
};
$32b8c10976407601$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 4, this.length);
    return $24dbd.read(this, offset, false, 23, 4);
};
$32b8c10976407601$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 8, this.length);
    return $24dbd.read(this, offset, true, 52, 8);
};
$32b8c10976407601$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkOffset(offset, 8, this.length);
    return $24dbd.read(this, offset, false, 52, 8);
};
function $32b8c10976407601$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$32b8c10976407601$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$32b8c10976407601$var$Buffer.prototype.writeUintLE = $32b8c10976407601$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $32b8c10976407601$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$32b8c10976407601$var$Buffer.prototype.writeUintBE = $32b8c10976407601$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $32b8c10976407601$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$32b8c10976407601$var$Buffer.prototype.writeUint8 = $32b8c10976407601$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$32b8c10976407601$var$Buffer.prototype.writeUint16LE = $32b8c10976407601$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$32b8c10976407601$var$Buffer.prototype.writeUint16BE = $32b8c10976407601$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$32b8c10976407601$var$Buffer.prototype.writeUint32LE = $32b8c10976407601$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$32b8c10976407601$var$Buffer.prototype.writeUint32BE = $32b8c10976407601$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$32b8c10976407601$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $32b8c10976407601$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$32b8c10976407601$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $32b8c10976407601$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$32b8c10976407601$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$32b8c10976407601$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$32b8c10976407601$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$32b8c10976407601$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$32b8c10976407601$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $32b8c10976407601$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $32b8c10976407601$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $24dbd.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$32b8c10976407601$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $32b8c10976407601$var$writeFloat(this, value, offset, true, noAssert);
};
$32b8c10976407601$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $32b8c10976407601$var$writeFloat(this, value, offset, false, noAssert);
};
function $32b8c10976407601$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32b8c10976407601$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $24dbd.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$32b8c10976407601$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $32b8c10976407601$var$writeDouble(this, value, offset, true, noAssert);
};
$32b8c10976407601$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $32b8c10976407601$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$32b8c10976407601$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$32b8c10976407601$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$32b8c10976407601$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$32b8c10976407601$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $32b8c10976407601$var$Buffer.isBuffer(val) ? val : $32b8c10976407601$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $32b8c10976407601$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $32b8c10976407601$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($32b8c10976407601$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $32b8c10976407601$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $32b8c10976407601$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $32b8c10976407601$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $32b8c10976407601$var$base64ToBytes(str) {
    return $6WdfO.toByteArray($32b8c10976407601$var$base64clean(str));
}
function $32b8c10976407601$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $32b8c10976407601$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $32b8c10976407601$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $32b8c10976407601$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("6WdfO", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $50d270d5e9e158c6$export$d622b2ad8d90c771; }, function (v) { return $50d270d5e9e158c6$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $50d270d5e9e158c6$export$6100ba28696e12de; }, function (v) { return $50d270d5e9e158c6$export$6100ba28696e12de = v; });
var $50d270d5e9e158c6$export$a48f0734ac7c2329;
var $50d270d5e9e158c6$export$d622b2ad8d90c771;
var $50d270d5e9e158c6$export$6100ba28696e12de;
"use strict";
$50d270d5e9e158c6$export$a48f0734ac7c2329 = $50d270d5e9e158c6$var$byteLength;
$50d270d5e9e158c6$export$d622b2ad8d90c771 = $50d270d5e9e158c6$var$toByteArray;
$50d270d5e9e158c6$export$6100ba28696e12de = $50d270d5e9e158c6$var$fromByteArray;
var $50d270d5e9e158c6$var$lookup = [];
var $50d270d5e9e158c6$var$revLookup = [];
var $50d270d5e9e158c6$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $50d270d5e9e158c6$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $50d270d5e9e158c6$var$i = 0, $50d270d5e9e158c6$var$len = $50d270d5e9e158c6$var$code.length; $50d270d5e9e158c6$var$i < $50d270d5e9e158c6$var$len; ++$50d270d5e9e158c6$var$i){
    $50d270d5e9e158c6$var$lookup[$50d270d5e9e158c6$var$i] = $50d270d5e9e158c6$var$code[$50d270d5e9e158c6$var$i];
    $50d270d5e9e158c6$var$revLookup[$50d270d5e9e158c6$var$code.charCodeAt($50d270d5e9e158c6$var$i)] = $50d270d5e9e158c6$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$50d270d5e9e158c6$var$revLookup["-".charCodeAt(0)] = 62;
$50d270d5e9e158c6$var$revLookup["_".charCodeAt(0)] = 63;
function $50d270d5e9e158c6$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $50d270d5e9e158c6$var$byteLength(b64) {
    var lens = $50d270d5e9e158c6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $50d270d5e9e158c6$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $50d270d5e9e158c6$var$toByteArray(b64) {
    var tmp;
    var lens = $50d270d5e9e158c6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $50d270d5e9e158c6$var$Arr($50d270d5e9e158c6$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i)] << 18 | $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i)] << 2 | $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i)] << 10 | $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $50d270d5e9e158c6$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $50d270d5e9e158c6$var$tripletToBase64(num) {
    return $50d270d5e9e158c6$var$lookup[num >> 18 & 0x3F] + $50d270d5e9e158c6$var$lookup[num >> 12 & 0x3F] + $50d270d5e9e158c6$var$lookup[num >> 6 & 0x3F] + $50d270d5e9e158c6$var$lookup[num & 0x3F];
}
function $50d270d5e9e158c6$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($50d270d5e9e158c6$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $50d270d5e9e158c6$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($50d270d5e9e158c6$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($50d270d5e9e158c6$var$lookup[tmp >> 2] + $50d270d5e9e158c6$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($50d270d5e9e158c6$var$lookup[tmp >> 10] + $50d270d5e9e158c6$var$lookup[tmp >> 4 & 0x3F] + $50d270d5e9e158c6$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("24dbd", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $18162dc02ff9d3d8$export$aafa59e2e03f2942; }, function (v) { return $18162dc02ff9d3d8$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $18162dc02ff9d3d8$export$68d8715fc104d294; }, function (v) { return $18162dc02ff9d3d8$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $18162dc02ff9d3d8$export$aafa59e2e03f2942;
var $18162dc02ff9d3d8$export$68d8715fc104d294;
$18162dc02ff9d3d8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$18162dc02ff9d3d8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5Mjji", function(module, exports) {

var $4lZp4 = parcelRequire("4lZp4");
var $43506a0b01436bd6$require$Buffer = $4lZp4.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $43506a0b01436bd6$var$padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) return input;
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = $43506a0b01436bd6$require$Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while(padLength--)buffer.write("=", position++);
    return buffer.toString();
}
module.exports.default = $43506a0b01436bd6$var$padString;

});



parcelRegister("1Newx", function(module, exports) {

$parcel$export(module.exports, "isDefinedUnknownObject", function () { return $14e5a22d904db4c1$export$4f3801818eda78c7; });
$parcel$export(module.exports, "isDefinedObject", function () { return $14e5a22d904db4c1$export$fe0f557bac37e4d2; });
var $14e5a22d904db4c1$export$4f3801818eda78c7 = function(value) {
    return typeof value === "object" && value !== null;
};
var $14e5a22d904db4c1$export$fe0f557bac37e4d2 = function(value) {
    return $14e5a22d904db4c1$export$4f3801818eda78c7(value);
};

});



parcelRegister("6WVAc", function(module, exports) {

$parcel$export(module.exports, "refreshGuestSession", function () { return $50f4d396ed0daaa3$export$7fbf17faa67273bf; });
$parcel$export(module.exports, "logoutGuest", function () { return $50f4d396ed0daaa3$export$eaf39aef1206eb6c; });
$parcel$export(module.exports, "postLogoutSuccessMessage", function () { return $50f4d396ed0daaa3$export$373c54fb61d0fc60; });
$parcel$export(module.exports, "postLogoutFailureMessage", function () { return $50f4d396ed0daaa3$export$28a3b9bdb658c019; });
$parcel$export(module.exports, "postLoginMessage", function () { return $50f4d396ed0daaa3$export$c2d6b1596bc84cd1; });

var $cT75T = parcelRequire("cT75T");
var $50f4d396ed0daaa3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $50f4d396ed0daaa3$var$fetchGuestAsync = ()=>$50f4d396ed0daaa3$var$__awaiter(void 0, void 0, void 0, function*() {
        const guest = yield (0, $cT75T.AccountManager).current.getGuestAsync(false);
        if (guest) {
            $50f4d396ed0daaa3$export$2f2124dd3dab8885(guest);
            return;
        }
        $50f4d396ed0daaa3$export$60a1460ecfa0c6fc();
    });
const $50f4d396ed0daaa3$export$7fbf17faa67273bf = ()=>{
    try {
        $50f4d396ed0daaa3$var$fetchGuestAsync();
    } catch (e) {
        $50f4d396ed0daaa3$export$60a1460ecfa0c6fc();
        throw e;
    }
};
const $50f4d396ed0daaa3$export$eaf39aef1206eb6c = ()=>{
    try {
        (0, $cT75T.AccountManager).current.logOut();
        $50f4d396ed0daaa3$export$373c54fb61d0fc60();
    } catch (err) {
        $50f4d396ed0daaa3$export$28a3b9bdb658c019();
        throw err;
    }
};
const $50f4d396ed0daaa3$export$2f2124dd3dab8885 = (guest)=>{
    const data = {
        type: "refresh-success",
        message: guest.idToken
    };
    window.parent.postMessage(data, "*");
};
const $50f4d396ed0daaa3$export$60a1460ecfa0c6fc = ()=>{
    const data = {
        type: "refresh-failure"
    };
    window.parent.postMessage(data, "*");
};
const $50f4d396ed0daaa3$export$373c54fb61d0fc60 = ()=>{
    const data = {
        type: "logout-success"
    };
    window.parent.postMessage(data, "*");
};
const $50f4d396ed0daaa3$export$28a3b9bdb658c019 = ()=>{
    const data = {
        type: "logout-failure"
    };
    window.parent.postMessage(data, "*");
};
const $50f4d396ed0daaa3$export$c2d6b1596bc84cd1 = (guest)=>{
    const data = {
        type: "login-success",
        message: guest.idToken
    };
    window.parent.postMessage(data, "*");
};

});


//# sourceMappingURL=index.d783798d.js.map
